import Vue from 'vue'
import VueRouter from 'vue-router'

import Alarm from '../views/Alarm.vue'
import Category from '../views/Category.vue'
import Changeinfo from '../views/Changeinfo.vue'
import ChangePass from '../views/ChangePass.vue'
import Charge from '../views/Charge.vue'
import Chargehistory from '../views/Chargehistory.vue'
import Chargehistory2 from '../views/Chargehistory2.vue'
import Complete from '../views/Complete.vue'
import Complete2 from '../views/Complete2.vue'
import Contact from '../views/Contact.vue'
import ContactWrite from '../views/ContactWrite.vue'
import index from '../views/index.vue'
import Joinus from '../views/Joinus.vue'
// import Joinus2 from '../views/Joinus2.vue'
import Mybookroom from '../views/Mybookroom.vue'
import Mybookroomcheck from '../views/Mybookroomcheck.vue'
import Notice from '../views/Notice.vue'
import FAQ from '../views/Faq.vue'
import Toondetail from '../views/Toondetail.vue'
import Usehistory from '../views/Usehistory.vue'
import Withdraw from '../views/Withdraw.vue'
import Withdrawhistory from '../views/Withdrawhistory.vue'
import Alliance from '../views/Alliance.vue'
import Alliancequestion from '../views/Alliancequestion.vue'
import Allianceend from '../views/Allianceend.vue'
import Findpass from '../views/Findpass.vue'
import Findpass2 from '../views/Findpass2.vue'
import Repass from '../views/Repass.vue'
import Hashtag from '../views/Hashtag.vue'
import Competition from '../views/Competition.vue'
import Search from '../views/Search.vue'
import Swap from '../views/Swap.vue'
import Viewer from '../views/Viewer.vue'
import ArtubeLeague from '../views/ArtubeLeague.vue'
import Enrollment from '../views/Enrollment.vue'
import LeagueMyWebtoon from '../views/LeagueMyWebtoon.vue'
import LeagueEpisodeReg from '../views/LeagueEpisodeReg.vue'
import LeagueEpisodeEdit from '../views/LeagueEpisodeEdit.vue'
import Service from '../views/Service.vue'
import Leaguedetail from '../views/Leaguedetail.vue'
import LeagueMypage from '../views/LeagueMypage.vue'
import LeagueMydetail from '../views/LeagueMydetail.vue'
import LeagueViewer from '../views/LeagueViewer.vue'
import LeagueMyViewer from '../views/LeagueMyViewer.vue'
import LeagueEvent from '../views/LeagueEvent.vue'


const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(() => {
        return window.location.reload();
    })
};

Vue.use(VueRouter)

const routes = [

    /******************************************** pc *********************************************/
    {path: '/',                                 name: 'index',                          component:index            },
    {path: '/Alarm',                            name: 'Alarm',                          component:Alarm            },
    {path: '/Category',                         name: 'Category',                       component:Category         },
    {path: '/Category/:idx',                    name: 'Category',                       component:Category         },
    {path: '/Category/:idx/:searchText',        name: 'Category',                       component:Category         },
    {path: '/Changeinfo',                       name: 'Changeinfo',                     component:Changeinfo       },
    {path: '/ChangePass',                       name: 'ChangePass',                     component:ChangePass       },
    {path: '/Charge',                           name: 'Charge',                         component:Charge           },
    {path: '/Charge/:type',                     name: 'ChargeType',                     component:Charge           },
    {path: '/Chargehistory',                    name: 'Chargehistory',                  component:Chargehistory    },
    {path: '/ChargehistoryATT',                 name: 'Chargehistory2',                 component:Chargehistory2   },
    {path: '/Complete',                         name: 'Complete',                       component:Complete         },
    {path: '/Complete2',                        name: 'Complete2',                      component:Complete2        },
    {path: '/Contact',                          name: 'Contact',                        component:Contact          },
    {path: '/Contact/Write',                    name: 'ContactWrite',                   component:ContactWrite     },
    {path: '/index',                            name: 'index',                          component:index            },
    {path: '/Joinus',                           name: 'Joinus',                         component:Joinus           },
    // {path: '/Joinus2',                          name: 'Joinus2',                        component:Joinus2       },
    {path: '/Mybookroom',                       name: 'Mybookroom',                     component:Mybookroom       },
    {path: '/Mybookroomcheck',                  name: 'Mybookroomcheck',                component:Mybookroomcheck  },
    {path: '/Notice',                           name: 'Notice',                         component:Notice           },
    {path: '/FAQ',                              name: 'FAQ',                            component:FAQ              },
    {path: '/Toondetail/:idx',                  name: 'ToondetailIdx',                  component:Toondetail       },
    // {path: '/Toondetail/:engName',           name: 'ToondetailName',                 component:Toondetail       },
    {path: '/Usehistory',                       name: 'Usehistory',                     component:Usehistory       },
    // {path: '/Viewer/:engName/:epidx',            name: 'ViewerEng',                    component:Viewer         },
    {path: '/Withdraw',                         name: 'Withdraw',                       component:Withdraw         },
    {path: '/Withdrawhistory',                  name: 'Withdrawhistory',                component:Withdrawhistory  },
    {path: '/Alliance',                         name: 'Alliance',                       component:Alliance         },
    {path: '/Alliancequestion',                 name: 'Alliancequestion',               component:Alliancequestion },
    {path: '/Allianceend',                      name: 'Allianceend',                    component:Allianceend      },
    {path: '/Findpass',                         name: 'Findpass',                       component:Findpass         },
    {path: '/Findpass2',                        name: 'Findpass2',                      component:Findpass2        },
    {path: '/pwreset/:email/:code',             name: 'Repass',                         component:Repass           },
    {path: '/Hashtag/:idx',                     name: 'Hashtag',                        component:Hashtag          },
    {path: '/Competition',                      name: 'Competition',                    component:Competition      },
    {path: '/Search',                           name: 'Search',                         component:Search           },
    {path: '/Swap',                             name: 'Swap',                           component:Swap             },
    {path: '/Viewer/:wtidx/:epidx',             name: 'ViewerWtidxEpidx',               component:Viewer           },
    {path: '/ArtubeLeague',                     name: 'ArtubeLeague',                   component:ArtubeLeague     },
    {path: '/Enrollment',                       name: 'Enrollment',                     component:Enrollment       },
    {path: '/LeagueMyWebtoon',                  name: 'LeagueMyWebtoon',                component:LeagueMyWebtoon  },
    {path: '/LeagueMyWebtoon/:idx',             name: 'LeagueMyWebtoonIdx',             component:LeagueMyWebtoon  },
    {path: '/LeagueEpisodeReg/:idx',            name: 'LeagueEpisodeReg',               component:LeagueEpisodeReg },
    {path: '/LeagueEpisodeEdit/:wtidx/:epidx',  name: 'LeagueEpisodeEditWtidxEpidx',    component:LeagueEpisodeEdit},
    {path: '/Service',                          name: 'Service',                        component:Service          },
    {path: '/Leaguedetail/:idx',                name: 'LeaguedetailIdx',                component:Leaguedetail     },
    {path: '/LeagueMypage',                     name: 'LeagueMypage',                   component:LeagueMypage     },
    {path: '/LeagueMydetail/:idx',              name: 'LeagueMydetailIdx',              component:LeagueMydetail   },
    {path: '/LeagueViewer/:wtidx/:epidx',       name: 'LeagueViewerWtidxEpidx',         component:LeagueViewer     },
    {path: '/LeagueMyViewer/:wtidx/:epidx',     name: 'LeagueMyViewerWtidxEpidx',       component:LeagueMyViewer   },
    {path: '/LeagueEvent',                      name: 'LeagueEvent',                    component:LeagueEvent      },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    // scrollBehavior () {
    //     // page scroll to top for all route navigations
    //     return { x: 0, y: 0 }
    // }
})

export default router;